<div class="d-flex flex-wrap option-toggle-switch">
  @for (option of options; track option) {
    <div
      class="option-toggle-switch__option"
      [class.selected]="option.key === selectedOption"
      (click)="optionSelected(option.key)">
      {{ option.label | translate }}
    </div>
  }
</div>